import { Box, Typography } from '@material-ui/core';

const VYCE_SITE_URL = 'https://vyce.io';

const PoweredByLines = () => (
  <>
    <Typography align="center" variant="body2" color="textSecondary" component="p" style={{ margin: 0 }}>
      Forms powered by Vyce
    </Typography>
    <Typography
      align="center"
      variant="body2"
      component="p"
      style={{ margin: 0, marginTop: 4, fontWeight: 700 }}
    >
      <a href={VYCE_SITE_URL} target="_blank" rel="noopener noreferrer" className="form-summary-footer-link">
        vyce.io
      </a>
    </Typography>
  </>
);

/** End-of-column footer on screen (scroll view). */
export const FormSummaryPoweredByScreen = () => (
  <Box
    className="form-summary-footer form-summary-screen-only"
    component="footer"
    width="100%"
    marginTop="auto"
    paddingTop={1}
  >
    <PoweredByLines />
  </Box>
);

/** Fixed repeat footer for @media print (styled in formExportPrint.css). */
export const FormSummaryPoweredByPrint = () => (
  <Box className="form-summary-print-only form-summary-print-page-footer">
    <PoweredByLines />
  </Box>
);
